import { render } from "./FormularioCategoriaAvaliacao.vue?vue&type=template&id=45da30c9&scoped=true"
import script from "./FormularioCategoriaAvaliacao.vue?vue&type=script&lang=js"
export * from "./FormularioCategoriaAvaliacao.vue?vue&type=script&lang=js"

import "./FormularioCategoriaAvaliacao.vue?vue&type=style&index=0&id=45da30c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45da30c9"]])

export default __exports__